export enum SubscriptionUpdatesActionType {
  SubsDigCancelRequest = 'pelo/preferences/subscriptions/CANCEL_DIGITAL_SUB',
  SubsDigCancelSuccess = 'pelo/preferences/subscriptions/CANCEL_SUCCESS',
  SubsDigCancelFailure = 'pelo/preferences/subscriptions/CANCEL_FAILURE',

  ReactivateRequest = 'pelo/preferences/subscription/details/REACTIVATE_REQUEST',
  ReactivateSuccess = 'pelo/preferences/subscription/details/REACTIVATE_SUCCESS',
  ReactivateFailure = 'pelo/preferences/subscription/details/REACTIVATE_FAILURE',
  SubsDigUpdatesClear = 'pelo/preferences/subscriptions/UPDATES_CLEAR',
}
